export const INVOICE_TYPES = {
  NATIONAL: 'NATIONAL-INVOICE',
  INTERNATIONAL: 'INTERNATIONAL-INVOICE',
  SUMMARY: 'SUMMARY-STATEMENT'
}
